<template>
  <div class="form-main">
    <p class="mb-3">Ihre Nachricht ist bei uns eingegangen. Nachfolgende Daten haben wir übermittelt:</p>
    
    <div class="text-left form-main mb-3">
      <div
        class="mb-2"
        v-for="config in configurationData"
        v-bind:key="config.id"
      >
        <template v-if="config.showInConfirmation">
          <p class="mb-0 font-weight-bolder">{{ config.label }}</p>
          <div v-if="Array.isArray(config.value)">
            <p class="mb-0" v-for="item in config.value" v-bind:key="item">
              {{ item }}
            </p>
          </div>
          <div v-else>
            <p class="mb-0">
              {{ config.value }}
            </p>
          </div>
        </template>
      </div>

      <div v-for="field in personalData" v-bind:key="field.id">
        <template v-if="field.showInConfirmation">
          <p class="mb-0 mr-1 font-weight-bolder d-inline">
            {{ field.label }}:
          </p>
          <template v-if="Array.isArray(field.value)">
            <p
              class="mb-0 d-inline"
              v-for="item in field.value"
              v-bind:key="item"
            >
              {{ item }}
            </p>
          </template>
          <template v-else>
            <p class="mb-0 d-inline">
              {{ field.value }}
            </p>
          </template>
        </template>
      </div>
    </div>
    <p>Sie erhalten in Kürze eine E-Mail, in der Sie Ihre E-Mail-Adresse bestätigen müssen.</p>
    <p class="mb-3 font-weight-bolder">Um Sie bestmöglich zu beraten, wird sich in den nächsten Tagen ein Mitarbeiter unseres Beratungsteams bei Ihnen melden.</p>


    <p>Viele Grüße<br>Ihr SLV Team</p>
  </div>
</template>
<script>
export default {
  name: "Success",
  props: {
    configurationData: Object,
    personalData: Object,
  },
};
</script>
